module.exports = __webpack_public_path__ + "static/img/0693.59b7b02c.png";